/**
 * Iterates through a list asynchronously
 * @param array any[]
 * @param callback function (pass in the individual array item as a parameter)
 * @returns Promise<void>
 */
export async function asyncForEach(
    array: any[],
    callback: (item: any, index: number, array: any[]) => any
): Promise<void> {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
    }
}

/**
 * Evaluates if a string is exactly an integer or not (made of all digits)
 * @param val string
 * @returns boolean
 */
export const isInteger = (val: string): boolean => {
    return /^\d+$/.test(val)
}

/**
 * Shuffles an array using the Fisher-Yates algorithm
 * @param array any[]
 */
export const shuffle = (array: any[]) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const temp = array[i]
        array[i] = array[j]
        array[j] = temp
    }
}
